import React, { useEffect, useState } from 'react';
import Divider from '@mui/material/Divider';
import { Col, Row } from 'react-bootstrap';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import Alert, { useAlert } from 'components/snacks/Alert';

import { editInfo, getCity, getProvince, getUserInfo } from 'api/Api';

const myStyle = {
  border: 'none',
  borderBottom: '2px solid #e7e4e4',
  backgroundColor: '#f5f8fa',
  color: '#5e6278',
  transition: 'color .2s ease,background-color .2s ease',
  minHeight: 'calc(1.5em + 1.65rem + 2px)',
  padding: '0.825rem 1.5rem',
  fontSize: '1.1em',
  borderRadius: '0.475rem',
  width: '100%'
};
const EditProf = () => {
  const [selectedProvince, setSelectedProvince] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [nid, setNid] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [phone, setPhone] = useState(null);
  const [postCode, setPostCode] = useState(null);
  const [address, setAddress] = useState(null);
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState('');

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const editProf = () => {
    const formData = new FormData();
    formData.append('nid', nid);
    formData.append('phone', phone);
    formData.append('state', state);
    formData.append('city', city);
    formData.append('post_code', postCode);
    formData.append('address', address);
    formData.append('email', email);

    let error_message = '';

    if (!nid || !email || !postCode || !phone || !city || !state || !address) {
      error_message = 'لطفا فیلدهای ستاره دار را تکمیل کنید.';
    } else if (
      (nid && !nid.match(/^\d+/)) ||
      (phone && !phone.match(/^\d+/)) ||
      (postCode && !postCode.match(/^\d+/))
    ) {
      error_message = 'لطفا عدد وارد کنید!';
    } else if (nid && nid.length !== 10) {
      error_message = 'کد ملی صحیح نیست!';
    } else if (phone && phone.length !== 11) {
      error_message = 'شماره تلفن صحیح نیست!';
    } else if (postCode && postCode.length < 10) {
      error_message = 'کد پستی صحیح نیست!';
    } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i)) {
      error_message = 'ایمیل را درست وارد کنید!';
    }
    if (error_message !== '') {
      alertStore.AddAlert({
        key: 'validation',
        message: error_message,
        severity: 'error',
        auto_hide: true
      });
    } else {
      setLoading(true);
      editInfo(formData, (isOk, data) => {
        if (isOk) {
          alertStore.AddAlert({
            key: 'success',
            message: data,
            severity: 'success',
            auto_hide: true
          });
        } else {
          alertStore.AddAlert({
            key: '400',
            message: data,
            severity: 'error',
            auto_hide: true
          });
        }
      });
    }
  };

  useEffect(() => {
    getUserInfo((isOk, data) => {
      if (isOk) {
        setLoading(false);
        setInfo(data.user_info);
      } else {
        setLoading(false);
        alertStore.AddAlert({
          key: '400',
          message: data,
          severity: 'error',
          auto_hide: true
        });
      }
    });
  }, []);

  useEffect(() => {
    setNid(info.nid);
    setPhone(info.phone);
    setEmail(info.email);
    setPostCode(info.post_code);
    setAddress(info.address);
    setState(info.state_id);
    setCity(info.city_id);
  }, [info]);

  useEffect(() => {
    getCity(state, (isOk, data) => {
      if (isOk) {
        setSelectedCities(data.cities);
      } else {
      }
    });
    getProvince((isOk, data) => {
      if (isOk) {
        setSelectedProvince(data.provinces);
      } else {
        alertStore.AddAlert({
          key: '400',
          message: data,
          severity: 'error',
          auto_hide: true
        });
      }
    });
  }, [state, city]);

  return (
    <>
      <Paper elevation={1} sx={{ marginBottom: '40px' }}>
        <div className="bg-white rounded-25 p-10">
          <h1 className={'f-13'}>ویرایش اطلاعات کاربری</h1>
          <Divider className={'mt-3'} style={{ backgroundColor: '#e8e8e8' }} />
          <Row>
            <Col lg={'8'} md={'12'}>
              <div
                className={
                  'd-flex flex-column justify-content-center align-items-start h-100'
                }
              >
                <Row className={'mt-5'}>
                  <Col lg={'4'} md={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span className={''}>کد ملی</span>
                      <input
                        type="text"
                        name="nid"
                        id={'nid'}
                        onChange={(e) => setNid(e.target.value)}
                        value={nid ? nid : ''}
                        style={{ borderBottom: '2px solid #e7e4e4', backgroundColor: "white" }}
                        className="form-control form-control-lg form-control-solid mb-3 mb-lg-0 f-1"
                      />
                    </label>
                  </Col>
                  <Col lg={'4'} md={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span className={''}>تلفن</span>
                      <input
                        type="text"
                        name="phone"
                        id="phone"
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone ? phone : ''}
                        style={{ borderBottom: '2px solid #e7e4e4' }}
                        className="form-control form-control-lg form-control-solid mb-3 mb-lg-0 f-1"
                      />
                    </label>
                  </Col>
                  <Col lg={'4'} md={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span className={''}>ایمیل:</span>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email ? email : ''}
                        style={{ borderBottom: '2px solid #e7e4e4' }}
                        className="form-control form-control-lg form-control-solid mb-3 mb-lg-0 f-1"
                      />
                    </label>
                  </Col>
                  <Col lg={'4'} md={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span>انتخاب استان</span>
                      <select
                        onChange={(e) => setState(e.target.value)}
                        style={myStyle}
                        name={'state'}
                        id={'state'}
                        value={state ? state : ''}
                      >
                        <option value={0} className={'f-08'}></option>
                        {selectedProvince.map((prov) => (
                          <option
                            key={prov.id}
                            value={prov.id}
                            // selected={info.state_id === parseInt(prov.id)}
                          >
                            {prov.name}
                          </option>
                        ))}
                      </select>
                    </label>
                  </Col>
                  <Col lg={'4'} md={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span>شهر</span>
                      <select
                        onChange={(e) => setCity(e.target.value)}
                        style={myStyle}
                        name={'city'}
                        id={'city'}
                        value={city ? city : ''}
                      >
                        <option value={0} className={'f-08'}>
                          {}
                        </option>
                        {selectedCities.map((city) => (
                          <option
                            key={city.id}
                            value={city.id}
                            // selected={info.city_id === parseInt(city.id)}
                          >
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </label>
                  </Col>
                  <Col lg={'4'} md={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span className={''}>کد پستی</span>
                      <input
                        type="text"
                        name="post_code"
                        id="post_code"
                        onChange={(e) => setPostCode(e.target.value)}
                        value={postCode ? postCode : ''}
                        style={{ borderBottom: '2px solid #e7e4e4' }}
                        className="form-control form-control-lg form-control-solid mb-3 mb-lg-0 f-1"
                        placeholder={''}
                      />
                    </label>
                  </Col>
                  <Col lg={'12'}>
                    <label className={'w-100 mb-7'}>
                      <span className={''}>آدرس:</span>
                      <textarea
                        name="address"
                        id="address"
                        onChange={(e) => setAddress(e.target.value)}
                        value={address ? address : ''}
                        rows={3}
                        style={{ borderBottom: '2px solid #e7e4e4' }}
                        className="form-control form-control-lg form-control-solid mb-3 mb-lg-0 f-1"
                        placeholder={''}
                      />
                    </label>
                  </Col>
                </Row>
                <Button
                  color={'primary'}
                  variant={'contained'}
                  className={'f-09 yekan-font'}
                  onClick={editProf}
                >
                  ثبت تغییرات
                </Button>
              </div>
            </Col>
            <Col lg={'4'} className={'d-lg-block d-none'}>
              <div
                className={'d-flex justify-content-center align-items-center'}
              >
                <img
                  src={'./../../assets/media/illustrations/dozzy-1/12.png'}
                  width={'70%'}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Paper>
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
};

export default EditProf;
